var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "video-jumbotron-section" },
    [
      _c("InlineVideo", {
        ref: "video",
        staticClass: "section__video stick-all-corners h-100 w-100",
        attrs: { poster: _vm.assets.INTRO_VIDEO_POSTER, sources: _vm.sources }
      }),
      _vm._v(" "),
      _c("IntersectionObserver", {
        staticClass: "stick-all-corners h-100 w-100",
        attrs: {
          handler: _vm.intersectionHandler,
          options: {
            threshold: 0.25
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "stick-all-corners flex-center flex-column" }, [
        _c(
          "div",
          { staticClass: "section__content container text-center py-5" },
          [
            _c(
              "JoinHeading",
              {
                staticClass: "text-center mb-6 text-white",
                attrs: { level: 1 }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("join.section.banner.title")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("JoinButton", { attrs: { href: _vm.assets.LINK_TO_CREATOR } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("join.section.banner.cta.label")) +
                  "\n      "
              )
            ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }